import { getTRSClusters } from './getTRSClusters';

export const fetchTRSClusters = async () => {
    try {
        const response = await getTRSClusters();
        return response.data;
    } catch (error) {
        console.error('Error fetching TRS clusters:', error);
        throw error;
    }
};
